let MAP;
let HOTEL_PIN;
let iconDefault;
let iconHover;
let CONFIG_MAP = {};
let GoogleMapsMarkers = [];

document.addEventListener('DOMContentLoaded', () => {  
    const ATTRACTIONS_MODULE = document.querySelector('section#attractions-module');
    
    if (ATTRACTIONS_MODULE) {
        (function handleHeaderSticky() {
            const header = document.getElementById("header");
            const hold   = document.querySelector(".sub-menu__hold");
            if (!header || !hold) return;

            const updatePos = () => {
                if (header.classList.contains("not-image")) {
                    hold.style.position = "fixed";
                    hold.style.top = header.offsetHeight + "px";
                } else {
                    hold.style.position = "";
                    hold.style.top = "";
                }
            };

            const observer = new MutationObserver(() => updatePos());
            observer.observe(header, { attributes: true, attributeFilter: ['class'] });
            window.addEventListener('resize', updatePos);
            updatePos();
        })();

        function switchActiveArticle(newActive) {
            const currentActive = document.querySelector('article[data-attraction]:not(.no-active)');
            if (currentActive && currentActive !== newActive) {
                currentActive.style.opacity = '0';
                setTimeout(() => {
                    currentActive.classList.add('no-active');
                    newActive.classList.remove('no-active');
                    newActive.style.opacity = '0';
                    newActive.offsetHeight; 
                    newActive.style.opacity = '1';
                    matchAttractionWithMarkers(newActive);
                }, 300);
            }
        }

        function updateAttractionFromArrow(arrow) {
            const attractionActive = document.querySelector('article[data-attraction]:not(.no-active)');
            const allAttractions = document.querySelectorAll('article[data-attraction]');
            
            if (!attractionActive || allAttractions.length <= 1) return;

            let newAttractionActive;
            if (arrow.classList.contains('js-prevAttrArrow') || arrow.closest('.js-prevAttrArrow')) {
                newAttractionActive = attractionActive.previousElementSibling || allAttractions[allAttractions.length - 1];
            } else {
                newAttractionActive = attractionActive.nextElementSibling || allAttractions[0];
            }
            switchActiveArticle(newAttractionActive);
        }

        function loadMarker(pin, map_selector, icon) {
            let marker = new google.maps.Marker({
                map: map_selector,
                title: pin.name,
                icon: icon,
                zIndex: 1,
                position: new google.maps.LatLng(pin.lat, pin.long),
            });

            marker.addListener('click', () => {
                let target = document.querySelector(`article[data-attraction][data-name="${marker.title}"]`);
                if(target) switchActiveArticle(target);
            });
            marker.addListener('mouseover', () => marker.setIcon(iconHover));
            marker.addListener('mouseout', () => {
                let activeArt = document.querySelector('article[data-attraction]:not(.no-active)');
                if (activeArt && activeArt.dataset.name !== marker.title) {
                    marker.setIcon(icon);
                }
            });
            return marker;
        }

        function matchAttractionWithMarkers(articleActiveOnList) {
            let nameTarget = typeof articleActiveOnList == 'string' ? articleActiveOnList : articleActiveOnList.dataset.name;
            GoogleMapsMarkers.forEach((itemMarker) => {
                if (itemMarker.title == nameTarget) {
                    itemMarker.setIcon(iconHover);
                    if (typeof articleActiveOnList != 'string' && MAP) {
                        MAP.panTo(itemMarker.getPosition());
                    }
                } else {
                    itemMarker.setIcon(iconDefault);
                }
            });
        }
        
        function getAttractionMarkUp(attraction, count, lengthAttractions) {
            const { id, name, thumb, description, address, label_visit_website, url } = attraction;
            let imageAttraction = thumb[0].full_size;
            let link = (url && url.trim() !== "") ? (url.indexOf('http') < 0 ? site_url + url : url) : null;
            let iconArrow = `<span><svg width="50" height="50" viewBox="0 0 50 50"><path d="M25 41C33.8294 41 41 33.8294 41 25C41 16.1706 33.8294 9 25 9C16.1706 9 9 16.1706 9 25C9 33.8294 16.1706 41 25 41Z" fill="white"/><path d="M29 31.1144L28.0513 32L21 25L28.0513 18L28.9987 18.8856L22.8552 25L29 31.1144Z" fill="#322C2A"/></svg></span>`;
            
            let arrows = lengthAttractions > 1 ? `
                <div class="attractions_arrow">
                    <button class="attractions_prevArrow js-prevAttrArrow" data-arrow>${iconArrow}</button>
                    <button class="attractions_nextArrow js-nextAttrArrow" data-arrow>${iconArrow}</button>
                </div>` : '';

            return `
                <article data-attraction="${id}" class="eachAttraction ${count > 0 ? 'no-active' : ''}" data-name="${name}" style="opacity: ${count === 0 ? '1' : '0'}">
                    <div class="eachAttraction_wrapper">
                        <figure class="eachAttraction_image">
                            <img src="${imageAttraction}" alt="${name}">
                            ${arrows}
                        </figure>
                        <div class="eachAttraction_info">
                            <h2 class="eachAttraction_title sym-h4">${name}</h2>
                            <div class="eachAttraction_addres">${address}</div>
                            <p class="eachAttraction_description">${description}</p>
                            ${link ? `<a class="pin-website" href="${link}" target="_blank">${label_visit_website}</a>` : ''}
                        </div>
                    </div>
                </article>`;
        }
        
        function GetAttractionsMarkup(attractions) {
            const ATTRACTIONS_WRAPPER = document.querySelector('.attractions_content');
            
            ATTRACTIONS_WRAPPER.innerHTML = ""; 

            if (attractions.length === 0) {
                ATTRACTIONS_WRAPPER.innerHTML = "<p>No attractions found in this category.</p>";
                return;
            }

            const html = attractions.map((a, i) => getAttractionMarkUp(a, i, attractions.length)).join('');
            ATTRACTIONS_WRAPPER.innerHTML = html;

            const generalArrows = document.querySelectorAll('.attractions_arrows [data-arrow]');
            const internalArrows = document.querySelectorAll('.attractions_arrow [data-arrow]');

            const displayStyle = attractions.length <= 1 ? 'none' : 'flex';
            
            if (generalArrows) generalArrows.forEach(arrow => arrow.style.display = displayStyle);

            const allArrows = [...generalArrows, ...internalArrows];
            allArrows.forEach(arrow => {
                arrow.onclick = (e) => {
                    e.preventDefault();
                    updateAttractionFromArrow(arrow);
                };
            });
        }
        function LoadGoogleMaps(config, pins) {
            const GOOGLE_MAPS_WRAPPER = document.querySelector('#attractions-map');
            GoogleMapsMarkers = [];
            MAP = new google.maps.Map(GOOGLE_MAPS_WRAPPER, {
                zoom: parseInt(config.map_zoom) || 13,
                center: new google.maps.LatLng(config.hotel_pin.lat, config.hotel_pin.long),
                mapTypeId: 'roadmap',
                styles: config.snazzy ? JSON.parse(config.snazzy) : [],
                scrollwheel: false,
                zoomControl: true
            });
            pins.forEach((pin) => {
                GoogleMapsMarkers.push(loadMarker(pin, MAP, config.regular_pin.normal));
            });
        }
        
        function GetAttractions(category) {
            const wrapper = document.querySelector('.attractions_content');
            wrapper.style.opacity = '0.5';

            fetch(`${site_url}ajax/functions.php?operation=FrontendLoadAttractionsCustom&category=${encodeURIComponent(category)}`)
                .then(resp => resp.json())
                .then(data => {
                    wrapper.style.opacity = '1';
                    GetAttractionsMarkup(data.pins);
                    LoadGoogleMaps(data.config, data.pins);
                    
                    if (data.pins.length > 0) {
                        matchAttractionWithMarkers(data.pins[0].name);
                    }
                })
                .catch(err => {
                    console.error("Error loading attractions:", err);
                    wrapper.style.opacity = '1';
                });
        }
        
        iconDefault = marker_url;
        iconHover = marker_hover_url;
        const ATTRACTIONS_FILTER = document.querySelector('#attractions-filter');
        const LABEL_FILTER = document.querySelector('.attractions_labelFilter');

        ATTRACTIONS_FILTER.addEventListener('click', (e) => {
            let li = e.target.closest('li');
            if (li) {
                ATTRACTIONS_FILTER.querySelectorAll('li').forEach(el => el.classList.remove('active'));
                li.classList.add('active');
                GetAttractions(li.dataset.category);
                if (LABEL_FILTER) {
                    ATTRACTIONS_FILTER.classList.remove('open');
                    LABEL_FILTER.textContent = li.textContent;
                }
            }
        });

        if (LABEL_FILTER) {
            LABEL_FILTER.addEventListener('click', () => {
                ATTRACTIONS_FILTER.classList.toggle('open');
            });
        }

        const initialLi = ATTRACTIONS_FILTER.querySelector('li');
        if (initialLi) initialLi.click();
    }
});